export default {
  user_success_update:
    "Incorrect email format personal data modified successfully",
  custom_mes_email: "The email format is incorrect",
  custom_mes_verification: "The verification code is not correct",
  custom_mes_phone: "The cell phone number cannot be empty",
  userinfo_msg_email: "Please enter right email",
  userinfo_msg_verification: "The verification code cannot be empty",
  userinfo_msg_phone: "Please enter right phone number",
  userinfo_msg_name: "Name cannot be empty",
  userinfo_btn: "submit",
  userinfo_email: "email",
  userinfo_verification_code: "verification code",
  userinfo_phone: "phone",
  userinfo_userName: "name",
  userinfo_title: "Supplementary personal data",
  expo_notice: "Exhibition notice",
  dock_customer_service: "customer service",
  dock_feedback: "feedback",
  dock_top: "top",
  btn_switch_expo: "switch",
  schedule: "Schedule",
  self_service: "Self Service",
  self_service_desc: "Versatile self-service to meet all your needs",
  special_booth: "special booth",
  normal_booth: "Standard booth",
  modify_info: "modify info",
  change_pass: "change password",
  login: "login",
  register: "register",
  account_info: "account",
  booth_info: "booth",
  check_drawing: "Check Drawing",
  mandatory_fee: "Mandatory Fee",
  non_booth: "no booth available",
  bind_booth_tips1: "try to ",
  bind_booth_tips2: "your booth",
  bind_link: "Bing",
  normal_booth_tips: "Standard booth does not require review",
  contact_info: "Project Information",
  download_info: "Download Information",
  download: "download",
  feedback_title: "Feedback",
  feedback_placeholder: "please enter your valuable comments",
  expo_name_input: "exhibition name",
  expo_name_input_palceholder: "please enter the exhibition name",
  expo_start_time_input: "start time",
  expo_start_time_input_placeholder: "please enter the exhibition start time",
  change_expo_tips:
    "If the reservation you have booked has been closed, you can check it out.",
  change_expo_tips_link: "Historical order",
  download_error_tips: "Please select the information you need to download.",
  download_confirm: "Are you sure you want to download the selected material?",
  feedback_error_tips: "please enter your opinion",
  feedback_success_tips: "Thank you for your support and feedback",
  miss_tel_msg:
    "There is no contact information at present. Please contact the home configuration.",
  miss_downlaodData_msg: " No data available for download.",
  insufficient_authority: "You haven't logged in yet. You can't view it. ",
  展会公告: "Notice",
  查看更多: "More",
  从: "Start",
  至: "End",
  详情: "Show Detail",
  公告详情: "Detail",
  当前展会暂未公布时间安排:
    "The current exhibition has not yet announced the schedule"
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/main.js